import { useRoutesByBrand } from "@gymflow/api";
import { usePortalRoutes } from "apps/portal/src/hooks";
import { useContext, useMemo } from "react";

import { ApiResolverContext } from "../../../providers/ApiResolverProvider/ApiResolverContext";
import { TagsPopover } from "../../atoms";

type StaffLocationsTagsProps = {
  accessibleClubIds: number[];
};

export const StaffLocationsTags = ({
  accessibleClubIds,
}: StaffLocationsTagsProps) => {
  const { brand } = usePortalRoutes();
  const { data: routesData } = useRoutesByBrand({
    brand,
    page: 0,
    limit: 200,
  });
  const { clubId } = useContext(ApiResolverContext);

  const tags = useMemo(() => {
    const mappedTags = accessibleClubIds.map((accessClubId) => {
      const clubName = routesData?.results?.find(
        ({ clubId }) => accessClubId === clubId,
      )?.displayName;

      return {
        label: (clubName ?? accessClubId).toString(),
        item: { clubId: accessClubId, clubName },
      };
    });

    return mappedTags.sort((a, b) => {
      if (a.item.clubId === clubId) return -1;
      if (b.item.clubId === clubId) return 1;
      return a.label.localeCompare(b.label);
    });
  }, [accessibleClubIds, routesData, clubId]);

  return (
    <TagsPopover
      tags={tags}
      badgeClassName="rounded-full whitespace-nowrap overflow-hidden text-ellipsis"
    />
  );
};
